import { useState, lazy, Suspense } from "react";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ExperienceSection from "@/components/ExperienceSection";
import PortfolioFooter from "@/components/PortfolioFooter";

const SkillsMatrix = lazy(() => import("@/components/SkillsMatrix"));
const JDAnalyzer = lazy(() => import("@/components/JDAnalyzer"));
const AIChatDrawer = lazy(() => import("@/components/AIChatDrawer"));

const Index = () => {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <Navigation onOpenChat={() => setChatOpen(true)} />
      <main>
        <HeroSection onOpenChat={() => setChatOpen(true)} />
        <ExperienceSection />
        <Suspense fallback={<div className="py-24" />}>
          <SkillsMatrix />
          <JDAnalyzer />
        </Suspense>
      </main>
      <PortfolioFooter />
      <Suspense fallback={null}>
        <AIChatDrawer open={chatOpen} onClose={() => setChatOpen(false)} />
      </Suspense>
    </div>
  );
};

export default Index;
